const common = {
  "nav.home": "ホーム",
  "nav.services": "サービス",
  "nav.about": "Medigreen について",
  "nav.contact": "お問い合わせ",
  "nav.cta": "お問い合わせ",

  "footer.brand.desc": "原油・LNG調達に特化した専門アドバイザリーサービス。戦略的な洞察と確かな成果をお届けします。",
  "footer.nav.title": "ナビゲーション",
  "footer.contact.title": "お問い合わせ",
  "footer.address": "1411 PALE SAN VITORES ROAD, STE 303,\nTAMUNING, GU",
  "footer.phone": "+1.671.482.0104",
  "footer.email": "info@medigreen.energy",
  "footer.copyright": "© 2026 Medigreen LLC. All rights reserved.",
  "footer.privacy": "プライバシーポリシー",
  "footer.terms": "利用規約",

  "common.readMore": "続きを読む",
  "common.viewAll": "すべて見る",
  "common.learnMore": "詳しく見る",
  "common.contactUs": "お問い合わせ",
  "common.getStarted": "始める",
  "common.freeConsultation": "無料相談",
  "common.scheduleConsultation": "無料相談を予約する",
  "common.workWithUs": "一緒に働く",
  "common.viewAllNews": "ニュース一覧",
  "common.viewAllServices": "サービス一覧",
  "common.startConversation": "相談を始める",
  "common.learnMoreAboutUs": "私たちについて詳しく",
};

export default common;
